/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoices_TitleInputs */

const es_billing_invoices_title = /** @type {(inputs: Billing_Invoices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturas`)
};

const en_billing_invoices_title = /** @type {(inputs: Billing_Invoices_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices`)
};

/**
* | output |
* | --- |
* | "Invoices" |
*
* @param {Billing_Invoices_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_invoices_title = /** @type {((inputs?: Billing_Invoices_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoices_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_invoices_title(inputs)
	return en_billing_invoices_title(inputs)
});
export { billing_invoices_title as "billing.invoices.title" }